module.exports = __webpack_public_path__ + "img/cart.47d7ddfc.svg";